import { render, staticRenderFns } from "./DatasetList.vue?vue&type=template&id=6daf7dd8"
import script from "./DatasetList.vue?vue&type=script&lang=js"
export * from "./DatasetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports